/* eslint-disable react/no-array-index-key */
import React from 'react'

import { pathOr } from 'ramda'
import styled, { keyframes } from 'styled-components'

import { palette } from '_styles/variables'

export interface LoaderColumn {
  width: number | string
  height: number | string
}

type RowTemplate = LoaderColumn[]

export interface RowLoaderConfig {
  rowTemplate?: RowTemplate
  numRows?: number
}

const placeHolderShimmer = keyframes`
  0% {
    background: #ececec;
  }
  
  30% {
    background: #F7F7F7;
  }
 
  50% {
    background: #ececec;
  }
  
  80% {
    background: #F7F7F7;
  }
  
  100% {
    background: #ececec;
  }
`

const RowContainer = styled.tr`
  display: flex;
  height: 3.625rem;
  border: 1px solid ${palette.neutral['grey-ebebeb']};
  border-top: none;
  align-items: center;
  justify-content: space-around;
`

const SkeletonColumn = styled.td<LoaderColumn>`
  background-color: ${palette.transparent['black-15']};
  width: ${({ width }) => width};
  height: ${({ height }) => height};

  animation: ${placeHolderShimmer} 3s infinite;
`

const defaultTemplate: RowTemplate = Array.from({ length: 6 }, () => ({
  width: '6.25rem',
  height: '1rem',
}))

export const renderSkeletonRowLoader = (config?: RowLoaderConfig) => {
  const template = pathOr(defaultTemplate, ['rowTemplate'], config)
  const length = pathOr(4, ['numRows'], config)

  return (
    <>
      {Array.from({ length }).map((_, i) => (
        <RowContainer key={i}>
          {template?.map((column, j) => (
            <SkeletonColumn key={j} {...column} />
          ))}
        </RowContainer>
      ))}
    </>
  )
}
